// Based on src/components/dialog/UploadFileDialog

import React, { useContext, useEffect, useRef, useState } from 'react';
import { 
    Box,
    Button,
    ClickAwayListener,
    Fade,
    Popper,
    Typography,
    Checkbox,
    FormControlLabel
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import GreenButton from '../buttons/GreenButton';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { useAuth0 } from "@auth0/auth0-react";

import ProjectContext from '../../contexts/ProjectContext';
import UserContext from '../../contexts/UserContext';
import {useFetch} from '../../components/auth/useFetch';


export default function DownloadDialog(props) {

    const { anchorEl, clickAway, open, downloadClick, parentIconButtonDisabled, setParentIconButtonDisabled, filename } = props
    const { konsolUser, setKonsolUser } = useContext(UserContext)
    const projectContext = useContext(ProjectContext);
    const [fileList, setFileList] = useState([])
    const [sources, setSources] = useState({})
    const [source, setSource] = useState('')
    const [isUploading, setIsUploading] = useState(false)
    const [disableWarningsButtonText, setDisableWarningsButtonText] = useState('Hide warning for future downloads')
    const [disableWarningsButtonDisabled, setDisableWarningsButtonDisabled] = useState(false)
    const [disableWarningsButtonColor, setDisableWarningsButtonColor] = useState('rgba(0 0 0 0)')
    const [disableWarningsButtonTextColor, setDisableWarningsButtonTextColor] = useState('white')
    const fetchWithAuth = useFetch()


    async function disableFutureWarnings(){
        const user_metadata = konsolUser?.user_metadata ?? {}
        user_metadata.warndlsecurity = false
        var raw = JSON.stringify(user_metadata);
        var requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-Project-ID': projectContext?.project_db,
            },
            body: raw,
            redirect: 'follow',
        };
        fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/user/settings/`, requestOptions)
            .then(response => {
                if(response.status === 200 || response.status === 204){
                    setDisableWarningsButtonText("Preferences updated")
                    setDisableWarningsButtonDisabled(true)
                    setDisableWarningsButtonColor('rgba(0,0,0,0')
                    setKonsolUser((prev) => {
                        return { ...prev, user_metadata }
                    })
                }
                else{
                    setDisableWarningsButtonText("Unable to update preferences. Please try again later.")
                    setDisableWarningsButtonColor('red')
                }
            })
            .catch(e => {
                console.error(e);
            })
    }

    const DIALOG_WIDTH = 720
    const DIALOG_HEIGHT = 584

    return (
        <Popper
            id={open ? 'download-popper' : undefined}
            open={open}
            // Undefined anchorEl, we need it otherwise MUI throws a warn
            PopperProps={{style:{zIndex:1000}}}
            transition
            disablePortal
            style={{position: 'absolute', marginLeft:'50vw', left: -DIALOG_WIDTH/2, marginTop:'20vh' }}
    
            modifiers={[
                {
                    name: 'preventOverflow',
                    enabled: false,
                    options: {
                        altAxis: false,
                        altBoundary: false,
                        tether: false,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        >
        {({ TransitionProps }) => (
             <ClickAwayListener onClickAway={clickAway}>
                <Fade {...TransitionProps}>
                    <Box
                        width={'720px'}
                        height={'584px'}
                        display="flex"
                        flexDirection="column"
                        backgroundColor={'rgba(0,0,0,0.9)'}
                        sx={{
                            border: '2px solid rgba(50, 180, 65, 1)',
                            borderRadius: '8px'
                        }}
                    >
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'30px'}
                                sx={{flexDirection:'column'}}
                            >                                
                                <Typography color={'white'} component="span" variant="h5" align="center" gutterBottom>
                                    You are about to download 
                                </Typography>
                                <Typography color={'white'} component="span" variant="h4" align="center" gutterBottom>
                                    {filename}  
                                </Typography>                 


                                <br></br>{filename}               
                            </Box>
                        

                            <Box
                                width={'100%'}
                                height={'100%'}
                                display="flex"
                                flexDirection="column"
                                justifyContent="center"
                                alignItems="center"
                            >
                                
                                <PrivacyTipIcon style={{fill: "rgba(200,200,0,0.8)"}} sx={{ fontSize: 50 }} />
                                <br></br>
                                <Typography color={'white'} component="span" variant="h7" align="center" gutterBottom>
                                    Downloaded files are not encrypted. <br></br>
                                    Always store and transmit downloaded files securely.
                                </Typography>
                                <br/>
                                <Button onClick={disableFutureWarnings} disabled={disableWarningsButtonDisabled} 
                                    sx={{ 
                                        backgroundColor: disableWarningsButtonColor,
                                        color: disableWarningsButtonTextColor, 
                                        outline:'1px solid white',
                                        opacity:'0.8',
                                        '&:hover': {
                                            backgroundColor: disableWarningsButtonColor}
                                    }}>
                                        <Typography color='white' textTransform='none'>
                                            {disableWarningsButtonText}
                                        </Typography>
                                    </Button>
                            </Box>

                       
                            <Box
                                width='100%'
                                display={'flex'}
                                justifyContent={'center'}
                                marginTop={'auto'}
                                marginBottom="30px"
                            >                                
                                <GreenButton variant='contained' onClick={downloadClick} text='Download' />
                                
                            </Box>
                        
                    </Box>
                </Fade>
             </ClickAwayListener>
        )}
        </Popper>
    )}